





























































































































import Vue from "vue";
import Page from "../../../components/Page.vue";
import store, {
  IncomingInvoiceTypeStore,
} from "../services/IncomingInvoiceTypeStore";
import IncomingInvoiceType from "../models/IncomingInvoiceType";
import { t } from "@/plugins/i18n";

interface Data {
  store: IncomingInvoiceTypeStore;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    Page,
  },

  data(): Data {
    return {
      store,
    };
  },

  async beforeMount() {
    await Promise.all([this.store.loadInvoiceTypes()]);
  },

  computed: {
    columns: () => [
      { width: 200, field: "name", title: t("IncomingInvoice_BejovoSzlaTipus") },
      {
        field: "isDefault",
        title: t("Alapertelmezett"),
        cell: "isDefaultTemplate",
      },
      {
        field: "promptArrive",
        title: t("IncomingInvoice_ErkezettSzlaRogz"),
        cell: "promptArriveTemplate",
      },
      {
        field: "postCalc",
        title: t("IncomingInvoice_UtokalSzerepel"),
        cell: "postCalcTemplate",
      },
      { width: 200, field: "defAccgroup", title: t("Koltseghely") },
      {
        field: "isMustAccGroup",
        title: t("IncomingInvoice_KotKoltseghely"),
        cell: "isMustAccGroupTemplate",
      },
      { width: 80, field: "code", title: t("Tipuskod") },
      {
        field: "isExtData",
        title: t("IncomingInvoice_KiegAdatok"),
        cell: "isExtDataTemplate",
      },
      {
        field: "isContr",
        title: t("IncomingInvoice_Ellenorizheto"),
        cell: "isContrTemplate",
      },
      {
        field: "isInvPermit",
        title: t("IncomingInvoice_Utalvanyozhato"),
        cell: "isInvPermitTemplate",
      },
      {
        field: "isProject",
        title: t("IncomingInvoice_ProjectKapcsolat"),
        cell: "isProjectTemplate",
      },
      { width: 60, cell: "commandTemplate" },
    ],

    items() {
      return this.store.invoiceTypes;
    },
  },

  methods: {
    editItem(item: IncomingInvoiceType) {
      this.$router.push(`/incoming-invoice-type/edit/${item.id}`);
    },
  },
});
